import React, {Component} from 'react';
import PropTypes from "prop-types";

import './button.css';

class Button extends Component {
    constructor(props) {
        super(props);

        this.onClick = (e) => {
            if (this.props.disabled) return;

            if (this.props.href) {
                if (this.props.target === '_self') {
                    window.open(this.props.href, '_self');
                } else {
                    window.open(this.props.href, '_blank');
                }
            }
            try {
                this.props.onClick(e);
            } catch (e) {
                console.error(e);
            }
        };
    }

    render() {
        const {type, size, hint, startIcon, endIcon, disabled, customClass, style, children, fullWidth} = this.props;

        const isIconButton = (!children && !hint && (startIcon || endIcon));

        return (
            <div
                style={style}
                className={`button-component ${type} ${size} ${isIconButton ? 'icon' : ''} ${disabled ? 'disabled' : ''} ${fullWidth ? 'full-width' : ''} ${customClass}`}
                onClick={this.onClick}
            >
                {startIcon ? <div className='icon start-icon'>{startIcon}</div> : null}
                <div className='entry'>
                    {children && <div className='text'>{children}</div>}
                    {hint && <div className='hint'>{hint}</div>}
                </div>
                {endIcon ? <div className='icon end-icon'>{endIcon}</div> : null}
            </div>
        );
    }
}

Button.propTypes = {
    customClass: PropTypes.string,
    href: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.oneOf(['accent', 'transparent', 'outlined', 'secondary', 'primary', 'text']),
    size: PropTypes.oneOf(['x-small', 'small', 'medium', 'large', 'x-large', '']),
    hint: PropTypes.string,
    onClick: PropTypes.func,
    startIcon: PropTypes.node,
    endIcon: PropTypes.node,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    target: PropTypes.string,
};

Button.defaultProps = {
    customClass: '',
    style: null,
    type: 'primary',
    size: 'medium',
    onClick: () => {
    },
    startIcon: null,
    endIcon: null,
    hint: '',
    disabled: false,
    children: null
};

export default Button;